var Legend   = require("./Legend"),
    $        = require("jquery");

var BubbleLegend = Legend.extend({

    initialize: function (options) {
        var that = this;

        /*var tt = {
            'type'      : 3,
            'name'      : 'легенда пузырьков',
            'showValues': true,
            'minValue'  : 100,
            'maxValue'  : 500,
            'fill'      : '#ffffff',
            'isIcon'    : false,
            'separators': [{
                'value': '100500',
                'size' : 50,
                'idx'  : '1'
            }]
        };*/

        options || (options = {});

        options = $.extend(true, {
            "name"      : "",
            "showValues" : null
        }, options);

        BubbleLegend.__super__.initialize.apply(that, arguments);

        that._container.addClass('omjs-bubble-legend');

        that._buildLegend();
    },

    _getTemplate: function(){
        return require("./bubble.ejs");
    },

    setMinValue: function (value) {
        var that = this;

        if ($.type(value) !== "number") {
            return that;
        }

        that.options.minValue = value;
        that._buildLegend();

        return that;
    },

    setMaxValue: function (value) {
        var that = this;

        if ($.type(value) !== "number") {
            return that;
        }

        that.options.maxValue = value;
        that._buildLegend();

        return that;
    },

    setColor: function (color) {
        var that = this;

        if ($.type(color) !== "string") {
            return that;
        }

        that.options.fill   = color;
        that.options.isIcon = false;
        that._buildLegend();

        return that;
    },

    setIcon: function (icon) {
        var that = this;

        if ($.type(icon) !== "string") {
            return that;
        }

        that.options.fill   = icon;
        that.options.isIcon = true;
        that._buildLegend();

        return that;
    }
});

module.exports = BubbleLegend;


//////////////////
// WEBPACK FOOTER
// ./src/View/Widget/Legend/BubbleLegend.js
// module id = 211
// module chunks = 0